import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

interface Props {
  open: boolean;
  initialText: string;
  saving: boolean;
  onSave: (text: string) => void;
  onClose: () => void;
}

export const ExpertAppointmentOutcomeDialog: React.FC<Props> = ({ open, initialText, saving, onSave, onClose }) => {
  const [text, setText] = useState('');

  useEffect(() => {
    if (open) setText(initialText);
  }, [open, initialText]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Підсумок зустрічі</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={6}
          margin="dense"
          label="Результати консультації"
          placeholder="Опишіть результати зустрічі, рекомендації для клієнта..."
          value={text}
          onChange={e => setText(e.target.value)}
          inputProps={{ maxLength: 5000 }}
          helperText={`${text.length}/5000`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Відміна</Button>
        <Button
          variant="contained"
          onClick={() => onSave(text)}
          disabled={saving || !text.trim()}
        >
          {saving ? 'Збереження...' : 'Зберегти'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
